export default class Countdown {
	//modified after Tivoli
	constructor(element) {
		this.element = element;
		this.init();
	}

	init() {
		var countdownBtn = this.element.querySelector('.js-btn-countdown');
		var presaleBtn = this.element.querySelector('.js-btn-presale');
		var ticketBtn = this.element.querySelector('.js-btn-ticket');
		setCountDown(countdownBtn, presaleBtn, ticketBtn);


		function setCountDown(countdownBtn, presaleBtn, ticketBtn) {

			// Set the date we're counting down to
			var date = countdownBtn.dataset;

			var countDownDate = new Date(date.presaleTimestamp).getTime();

			// Get the client's timezone offset
			var tz_offset_js = new Date().getTimezoneOffset();

			// Get the server's timezone offset
			var tz_offset_server = countdownBtn.dataset.timezoneOffsetServer;

			// Update the count down every 1 second
			var x = setInterval(function () {

				// If the client changes their local timezone, prevent the ticket button will possibly be shown
				if (tz_offset_js !== new Date().getTimezoneOffset()) {
					return;
				}

				// Get today's date and time
				var now = new Date().getTime();

				// Calculate time difference between server and client
				var tz_difference = tz_offset_server - tz_offset_js;

				// Calculate time conforming server's timezone
				now -= tz_difference * 60 * 1000;

				// Find the distance between now and the count down date
				var distance = countDownDate - now;

				// Show countdown btn if less than 2 hours till presale && not in the past:
				if (distance < 7200000) {

					// Time calculations for days, hours, minutes and seconds
					var hours = Math.floor((distance % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60));
					var minutes = Math.floor((distance % (1000 * 60 * 60)) / (1000 * 60));
					var zero_m = (minutes < 10) ? 0 : '';
					var seconds = Math.floor((distance % (1000 * 60)) / 1000);
					var zero_s = (seconds < 10) ? 0 : '';

					// Output the result
					var countDown = countdownBtn.querySelector('.js-countdown-time');
					countDown.innerHTML = "0" + hours + ":" + zero_m + minutes + ":" + zero_s + seconds;

					// Hide presale btn:
					presaleBtn.classList.add('is-hidden');

					// Show presale btn:
					countdownBtn.classList.remove('is-hidden');

					// Pulsen bij 30 seconden:
					if (distance < 30000) {
						countdownBtn.classList.add('do-pulse'); // todo FE
					}

					if (distance < 0) {
						presaleBtn.classList.add('is-hidden');
						countdownBtn.classList.add('is-hidden');
						countdownBtn.classList.remove('do-pulse');
						ticketBtn.classList.remove('is-hidden');
					}

				}

			}, 1000); // end set interval function

		} // end setcountdown

	}
}
